import { useCallback } from 'react';

import { useUpdateDealItemField } from '@/lib/hooks/useUpdateDealItemField';

/**
 * Sets the declared VAT rate of a deal item, optimistically. Items on VAT on
 * margin are left alone: their rate is not the one that applies, which is why
 * the rate picker is hidden for them.
 */
export const useApplyVatRate = (dealId: string) => {
  const updateField = useUpdateDealItemField(dealId);

  return useCallback(
    async (id: string, vatRate: number) => {
      await updateField(id, {
        patch: (item) => (item.activeVersion.hasVatMargin ? null : { vatRate }),
        errorContext: 'applyVatRate',
        modifiedFields: ['vatRate'],
      });
    },
    [updateField]
  );
};
